module.exports = __webpack_public_path__ + "img/76.11ea9a30.jpg";